import React from 'react';
import { Flex } from '@balance-web/flex';
import { Stack } from '@balance-web/stack';
import { SpotCaution } from '@balance-web/illustration';
import { Button } from '@balance-web/button';
import { Text } from '@balance-web/text';
import { Heading } from '@balance-web/heading';

// A generic fallback component in case of error with the ability to reload the app
export const GenericFallback = ({
  resetError,
}: {
  resetError?: () => void;
}) => {
  return (
    <Flex alignItems="center" flex={1} justifyContent="center">
      <Stack align="center" gap="xlarge">
        <SpotCaution />
        <Stack gap="xsmall">
          <Heading align="center" level="6">
            Something went wrong
          </Heading>
          <Text align="center" color="textSecondary">
            We can't complete your request. Reload the page or log out if the
            issue persists.
          </Text>
        </Stack>
        <Button
          block
          label="Try again "
          onClick={resetError || window.location.reload}
        />
      </Stack>
    </Flex>
  );
};
